<script>import { connectHits } from "instantsearch.js/es/connectors";
import connect from "../connect";
import { cx } from "../utils";
export let escapeHTML = void 0;
export let transformItems = void 0;
export let classes = {};
const state = connect(
  connectHits,
  {
    escapeHTML,
    transformItems
  },
  { $$widgetType: "svelte-ais.hits" }
);
$:
  ({ hits, sendEvent } = $state);
</script>

<div
  class={cx(
    "ais-Hits",
    classes.root,
    hits.length === 0 && cx("ais-Hits--empty", classes.emptyRoot),
  )}
>
  <ol class={cx("ais-Hits-list", classes.list)}>
    {#each hits as hit}
      <li class={cx("ais-Hits-item", classes.item)}>
        <slot {hit} {sendEvent}>
          <div style="word-break: break-all;">{JSON.stringify(hit).slice(0, 100)} /></div></slot
        >
      </li>
    {/each}
  </ol>
</div>
